<template>
  <div class="title">
    <span>{{ title }}</span>
    <span @click="fadeTools" id="close">
      <CloseSVG
        :fillColor="'#424753'"
        :strokeColor="'#fff'"
        :flipFill="'#fff'"
        :flipStroke="'#424753'"
        :propId="'tool-title-close'"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";
import { AccordianState } from "@/types";

export default defineComponent({
  name: "ToolTitle",
  components: {
    CloseSVG,
  },
  props: {
    title: String,
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    fadeTools(): void {
      const PAYLOAD: AccordianState = { isOpen: false, tool: "", key: 0 };

      this.$store.dispatch(ActionTypes.SET_ACCORDIAN_STATE, PAYLOAD);
    },
  },
});
</script>

<style scoped>
.title {
  width: 90%;
  min-height: 75px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title span {
  font-size: 24px;
}

#close {
  width: 30px;
  height: 30px;
}
</style>
